module.exports = __webpack_public_path__ + "img/4.42ff5308.png";